import { dateMonthFormatter, useInterpolatedTranslationKey, useTranslate } from '@dreryk/react-common';

import { medicalDevicesTranslationKeys } from '../../translations';

const GENITIVE_THRESHOLD = 4;
const ACCUSATIVE_LOWER_THRESHOLD = 2;

type DeviceCellDatesProps = {
   readonly firstSupplyDate: string;
   readonly supplyMonthsCount: number;
};
export const DeviceCellDates = (props: DeviceCellDatesProps): JSX.Element => {
   const translate = useTranslate();
   let monthsCountDeclension = medicalDevicesTranslationKeys.historicalMedicalDeviceOrder.denominatorSingle;
   if (props.supplyMonthsCount >= ACCUSATIVE_LOWER_THRESHOLD && props.supplyMonthsCount <= GENITIVE_THRESHOLD) {
      monthsCountDeclension = medicalDevicesTranslationKeys.historicalMedicalDeviceOrder.accusativePlural;
   }
   if (props.supplyMonthsCount > GENITIVE_THRESHOLD) {
      monthsCountDeclension = medicalDevicesTranslationKeys.historicalMedicalDeviceOrder.genitivePlural;
   }

   const datesTranslation = useInterpolatedTranslationKey(
      medicalDevicesTranslationKeys.historicalMedicalDeviceOrder.orderDates,
      {
         firstSupplyDate: dateMonthFormatter(props.firstSupplyDate),
         supplyMonthsCount: props.supplyMonthsCount,
         monthDeclension: translate(monthsCountDeclension),
      }
   );
   return <>{translate(datesTranslation)}</>;
};
